import React, { useEffect, useState } from 'react';
import axios, { AxiosResponse } from 'axios';
import CssBaseline from '@material-ui/core/CssBaseline';
import PrimarySearchAppBar from '../components/Appbar'
import Helmet from 'react-helmet';
import { Box, Button, Chip, Container, Divider, Grid, IconButton, InputBase, Tab, Tabs, Typography, withStyles } from '@material-ui/core';
import CreatorInfo from '../components/CreatorInfo';
import TagIcon from '@material-ui/icons/LocalOffer';
import { Link } from 'react-router-dom';
import { LicencesExpanded, Licences, Catagories, URLCatagories, LicenceLinks } from '../util/HardCodedLists';
import DownloadIcon from '@material-ui/icons/GetApp';
import InfoIcon from '@material-ui/icons/Info';
import Courasel from '../components/Courasel';
import SearchIcon from '@material-ui/icons/Search';
import ModelCard from '../components/ModelCard2';
import Footer from '../components/Footer';
import CommentSection from '../components/CommentSection';
import ModelModal from '../components/ModelModal';
import { modelCardProps } from '../types/modelcard';
import DisplayAxiosError from '../util/DisplayAxiosError';
import { useSnackbar } from 'notistack';
import BundleAttributionPopup from '../components/BundleAttribution';
import MUILink from '@material-ui/core/Link';
import BundleCreatorBar from '../components/BundleCreatorBar';
import { ModelBundle } from '../types/List';
import RTRenderer from '../components/RTRenderer';
import { ScrollbarContext } from 'react-scrollbars-custom';
// import CarbonAds from '../components/carbonAds';
import ReceiptIcon from '@material-ui/icons/Receipt';

interface propTypes {
    list: ModelBundle;
    isLoggedIn: any;
    history: any;
    isLoading: any;
}

let adCount = 0;

const BundleView = (props: propTypes) => {
    let updateString;
    if (props.list.LastUpdated)
        updateString = new Date(props.list.LastUpdated).toLocaleDateString("en-US", { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' });

    // Model filtering
    const [modelList, setModelList] = useState(props.list.Models);
    function HandleSearchInput(e) {
        let searchString = e.target.value.toLowerCase();
        let filteredList = props.list.Models.filter(model => {
            return (model.title.toLowerCase().includes(searchString));
        });
        setModelList(filteredList);
    }

    //Tab switching
    const [tabValue, setTabValue] = useState(0);
    const [quickViewModel, setquickViewModel] = useState<string>(null);

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [AttributionState, setAttributionState] = useState(false);

    //Get licences
    let licenceSet = new Set<string>();
    props.list.Models.forEach(model => licenceSet.add(model.licence));
    const licences = Array.from(licenceSet);

    //Get logged in user
    const [user, setUser] = React.useState(null);
    useEffect(() => {
        if (!props.isLoggedIn) return;
        setUser(JSON.parse(localStorage.getItem('user')));
    }, []);

    //Get comment count after page load 
    const [commentCount, setCommentCount] = useState(0);
    useEffect(() => {
        axios.get(`/api/comment/${props.list.PublicID}`)
            .then(res => {
                setCommentCount(res.data.length);
            }).catch(err => {
                console.log(err);
            });
        axios.get(`/api/bundle/${props.list.PublicID}/gettoken`); //pageview
    }, []);

    //Scroll to top on load
    const scrollbar = React.useContext(ScrollbarContext);
    useEffect(() => scrollbar.parentScrollbar.scrollToTop(), []);

    //Ad Rerender
    const [adKey, setadKey] = React.useState(234);
    React.useEffect(() => {
        setInterval(() => {
            if (adCount < 4) {
                setadKey(Math.random() * 10000);
                adCount++;
            }
        }, 1000 * 40);
    }, []);

    function Download(format) {
        setAttributionState(true);

        //Let user know if this is first time downloading 
        const timeoutid = setTimeout(() => {
            enqueueSnackbar("Zipping your models, This might take a sec...", { variant: 'info' })
        }, 3000);

        async function dl(response) {
            clearTimeout(timeoutid);

            let url = window.URL.createObjectURL(new Blob([response.data]));
            if (response.data.type === 'application/json') { //override url if it's cached
                let file = new Blob([response.data], { type: 'application/json' });
                const json = await file.text();
                url = JSON.parse(json).url;
            }

            //first time dl
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${props.list.Name}-${format}.zip`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        }

        axios.get(`/api/list/${props.list.PublicID}/download/${format}`, { withCredentials: true, responseType: 'blob' })
            .then(dl)
            .catch((e) => { DisplayAxiosError(e, enqueueSnackbar) });

        /* @ts-ignore*/
        // window.plausible('Download List', { props: { list: props.list.PublicID } });
        umami.track('Download List', { list: props.list.PublicID });
    }

    const IconButtonNoMargin = withStyles((theme) => ({
        startIcon: {
            margin: 0,
        },
    }))(Button);

    return (
        <>
            <CssBaseline />

            <Helmet>
                <title>{`${props.list.Name} by ${props.list.Owner.Username} | Free download`}</title>
                <meta name="description" content={`Download ${props.list.Models.length} fbx, obj + gltf models for free. No login required. Optimised for Unity, Unreal, Godot and AR/VR.`} />
                <meta property="og:image" content={`https://static.poly.pizza/${props.list.Images[0]}`}></meta>
                <meta property="twitter:image" content={`https://static.poly.pizza/${props.list.Images[0]}`}></meta>
            </Helmet>
            <PrimarySearchAppBar loggedIn={props.isLoggedIn} history={props.history} isLoading={props.isLoading} />

            <div className='mx-auto px-5 sm:px-0 max-w-full md:max-w-[80%]'>
                {/* Two part grid that collapsed into 1 for mobile */}
                <div className='grid grid-cols-2 mt-14 gap-5'>
                    <div className='col-span-2 md:col-span-1 h-full flex flex-col'>
                        {/* Header */}
                        <div className='flex justify-between flex-wrap'>
                            <Typography variant="h3" component="h1" className='!font-light w-full md:w-auto'>{props.list.Name}</Typography>
                            <CreatorInfo Creator={props.list.Owner} />
                        </div>
                        <Divider />

                        {/* Description*/}
                        {/* <Typography variant="body1" className='whitespace-pre-line py-7 pb-10' >{props.list.Description}</Typography> */}
                        <RTRenderer state={props.list.Description} />
                        <div className='flex-grow flex-col flex gap-3 justify-end'>

                            {/* Download */}
                            <div className='flex items-center gap-2 my-1'>
                                {/* <Button variant="contained" color="primary" className='h-10 !w-6'><FavouriteIcon /></Button> */}
                                <Button startIcon={<DownloadIcon />} onClick={() => Download('zip')} variant="outlined" color="primary" className='w-48 h-10'> Download FBX </Button>
                                <Button startIcon={<DownloadIcon />} onClick={() => Download('glb')} variant="outlined" color="primary" className='w-48 h-10'> Download GLTF </Button>
                                <IconButtonNoMargin color='default' startIcon={<InfoIcon className='brightness-75'/>} onClick={() => setAttributionState(true)} variant="outlined" className='h-10 !px-4'></IconButtonNoMargin>
                            </div>

                            {/* Meta */}
                            <Typography variant="body1" color="textSecondary" >Updated: {updateString} • {licences.length > 1 ? 'Licences' : 'Licence'}: {
                                licences.map((licence, index) => {
                                    return (
                                        <>
                                            <MUILink className='!text-gray-text-sec' href={LicenceLinks[licence]} target={'_blank'}>{LicencesExpanded[licence]}</MUILink>
                                            {index < licences.length - 1 ? ', ' : ''}
                                        </>
                                    )
                                })
                            }</Typography>

                            {/* Tags */}
                            <div className='flex items-end justify-start flex-wrap'>
                                <TagIcon className={'text-[#80868b] my-0 text-xl'} />
                                <Chip size="small" label="Low Poly" color="secondary" style={{ marginLeft: '7px' }} component={Link} to={`/explore`} clickable />
                                {props.list.Category && <Chip size="small" label={Catagories[props.list.Category]} color="secondary" style={{ marginLeft: '7px' }} component={Link} to={`/explore/${URLCatagories[0]}`} clickable />}
                                {props.list.Tags.map((tag) => {
                                    return <Chip size="small" key={tag} label={`#${tag}`} style={{ marginLeft: '7px', marginTop: '5px' }} component={Link} to={`/search/${tag}`} clickable />
                                })}
                            </div>


                        </div>

                    </div>
                    <div className='col-span-2 md:col-span-1 '>
                        <Courasel
                            className=' mt-4 xl:mt-[4.4rem] rounded'
                            images={props.list.Images}
                            FeaturedAsset={props.list.FeaturedAsset}
                        />
                    </div>
                </div>

                {/* Tabs + search */}
                <div className='mt-16 mb-4 flex flex-row-reverse w-full flex-wrap'>
                    <div className={`bg-gray-dark rounded-md flex items-center md:rounded-l-none justify-center px-4 w-full sm:w-auto ${tabValue !== 0 && 'hidden'}`} >
                        <div className={`rounded-full bg-gray-darkish relative w-52`}>
                            <div className={'p-2 h-full absolute pointer-events-none flex items-center justify-center'}>
                                <SearchIcon />
                            </div>
                            <InputBase
                                defaultValue={''}
                                placeholder="Search"
                                className='w-full translate-x-10'
                                onKeyUp={HandleSearchInput}
                            />
                        </div>
                    </div>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }} className='bg-gray-dark rounded-md md:rounded-r-none flex-grow'>
                        <Tabs value={tabValue} indicatorColor="primary" textColor="primary" onChange={(e, value) => setTabValue(value)}>
                            <Tab label={<span><Chip label={props.list.Models.length} className="mr-[6px]" size="small" />Models</span>} />
                            <Tab label={<span>{commentCount > 0 && <Chip label={commentCount} className="mr-[6px]" size="small" />}Comments</span>} />
                        </Tabs>
                    </Box>
                </div>

                {/* Models */}
                {tabValue === 0 &&
                    <Grid container spacing={6}>
                        {modelList.map((card: modelCardProps, index) => (
                            <Grid item key={card.id} xs={12} sm={6} md={4} lg={3}>
                                <ModelCard
                                    index={index}
                                    model={card}
                                    showLicence
                                    noAvatar
                                    noLink
                                    onClick={() => {
                                        setquickViewModel(card.publicID);
                                    }}
                                />
                            </Grid>
                        ))}
                    </Grid>
                }

                {/* Comments */}
                <div className='flex items-center px-[20vw] mb-20'>
                    <CommentSection
                        isLoggedIn={props.isLoggedIn}
                        rootID={props.list.PublicID}
                        showCount
                        visible={tabValue === 1}
                    />
                </div>
            </div>

            {/*<CarbonAds key={adKey} />*/}

            {/* Show Creator bar if it's my list */}
            {
                user && (props.list.Owner.Username === user.publicID || user.publicID === 'dook') && (
                    <BundleCreatorBar List={props.list} />
                )
            }

            <ModelModal
                modelID={quickViewModel}
                open={quickViewModel != null}
                setOpen={() => setquickViewModel(null)}
                isLoggedIn={props.isLoggedIn}
                changeModel={(delta) => {
                    const currentIndex = modelList.findIndex(x => x.publicID === quickViewModel);
                    const newIndex = currentIndex + delta;
                    const newModel = modelList[(newIndex + modelList.length) % modelList.length];
                    setquickViewModel(newModel.publicID);
                }}
            />

            <BundleAttributionPopup
                handleClose={() => { setAttributionState(false) }}
                snackbar={enqueueSnackbar}
                open={AttributionState}
                bundle={props.list}
                licence={licences.length > 1 ? 'mixed' : licences[0]}
            />
        </>
    );
}


BundleView.getInitialProps = async ({ req, res, match, history, location, ...ctx }) => {

    //Parse ID from end of seo optimised url
    let id = match.params.id;
    const words = id.split('-');
    const listID = words[words.length - 1];

    let listResp: AxiosResponse<any>;
    try {
        listResp = await axios.get(`${process.env.SITE_ROOT}/api/list/${listID}`);
    } catch (e) {
        return { statusCode: e.response.status };
    }

    //@ts-ignore
    const isLoggedIn = req !== undefined ? ctx.authed : authed;

    const Images = listResp.data.Images.map((image) => 'https://static.poly.pizza/' + image)

    return { isLoggedIn, list: { ...listResp.data, Images }, darkMode: ctx.darkMode }
}

export default BundleView;